export default __webpack_public_path__ + "images/blog2.png";